var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.714,
    height: 111.105,
    viewBox: "0 0 78.714 111.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "html 5",
    transform: "translate(-.445)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M79.159,70.766,71.988,151.1l-32.234,8.936L7.609,151.112.445,70.766Z",
    "data-name": "Path 267",
    transform: "translate(0 -48.931)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M128,167.927l26.047-7.221,6.128-68.649H128Z",
    "data-name": "Path 268",
    transform: "translate(-88.198 -63.653)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M58.686,133.849h13.94V124H47.917l.236,2.644,2.422,27.155H72.627V143.94H59.587Zm2.221,24.872H51.015l1.38,15.472,20.186,5.6.045-.012V169.532l-.043.011L61.609,166.58l-.7-7.859Z",
    "data-name": "Path 269",
    transform: "translate(-32.825 -85.736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,0h5.008V4.948h4.581V0h5.008V14.983H33.769V9.966H29.188v5.017H24.18V0ZM45.362,4.969H40.954V0H54.781V4.969H50.371V14.983H45.363V4.969h0ZM56.976,0H62.2l3.212,5.264L68.618,0h5.224V14.983H68.854V7.556l-3.445,5.327h-.086L61.875,7.556v7.426h-4.9ZM76.334,0h5.009V10.03h7.042v4.952H76.334V0Z",
    "data-name": "Path 270",
    transform: "translate(-16.412)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.889,153.794h12.134l-1.144,12.78-10.991,2.966v10.252l20.2-5.6.148-1.665,2.316-25.943.24-2.646H127.889Zm0-19.969v.024h23.8l.2-2.215.449-5,.235-2.644H127.889v9.83Z",
    "data-name": "Path 271",
    transform: "translate(-88.121 -85.737)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.9aa2e18f.svg";
export { ForwardRef as ReactComponent };